/* HHD: hide variant option values that don't exist for the current selection */
(function(){
  function data(){var s=document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
    if(s){try{return JSON.parse(s.textContent)}catch(e){}}
    return window.HHD_VARIANTS||null;}
  var busy=false;
  function run(){
    if(busy)return; var vs=data(); var root=document.querySelector('variant-selects'); if(!vs||!root)return;
    var sels=Array.prototype.slice.call(root.querySelectorAll('select')); if(!sels.length)return;
    busy=true; var changed=false;
    sels.forEach(function(sel,i){
      var prev=sels.slice(0,i).map(function(s){return s.value});
      var ok={}; vs.forEach(function(v){ if(prev.every(function(p,j){return v.options[j]===p})) ok[v.options[i]]=1; });
      var first=null;
      Array.prototype.forEach.call(sel.options,function(o){var good=!!ok[o.value]; o.hidden=!good; o.disabled=!good; if(good&&first===null)first=o.value;});
      if(!ok[sel.value]&&first!==null){sel.value=first;changed=sel;}
    });
    busy=false;
    if(changed) changed.dispatchEvent(new Event('change',{bubbles:true}));
  }
  document.addEventListener('change',function(e){ if(e.target.closest&&e.target.closest('variant-selects')) setTimeout(run,0); },true);
  new MutationObserver(function(){ setTimeout(run,0) }).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState!=='loading')run(); else document.addEventListener('DOMContentLoaded',run);
})();
